// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__15LM-","Main":"App_Main__5wsYB","Wrapper":"App_Wrapper__2vPXK"};